// FE-08 — Uygulama kabuğunun TEK kırılım noktası kaynağı.
//
// Kusur: kabukta (Layout/Sidebar/Header/global) hiç `@media` yoktu. Kenar çubuğu
// `position: fixed` + 260px sabit genişlikteydi ve `Layout`'un içerik alanı bunu
// `margin-left: 260px` ile telafi ediyordu. 390px'lik bir telefonda içerik alanı
// 390 - 260 = **130px**'e düşüyordu: tablo üç harflik bir şerit, satır menüsü
// ekran dışında, çekmecenin sol kenarı kesik. Yönetici sahadan hiçbir ekranı
// açamıyordu.
//
// Neden saf fonksiyon + JS kırılımı, neden salt CSS `@media` değil:
//   1. Off-canvas kenar çubuğunun DURUMU (açık/kapalı) zaten JS'te — hamburger
//      düğmesi, arka plan perdesi ve Esc kapatması CSS'le ifade edilemez.
//   2. `GenericFormDrawer`'ın genişliği `react-modern-drawer`'a **prop** olarak
//      gider (`size`), CSS sınıfı değil; bir `@media` bloğu ona ulaşamaz.
//   3. Ölçülebilirlik: jsdom'un düzen motoru yoktur — `getBoundingClientRect()`
//      her zaman sıfır döner ve `getComputedStyle` `@media` bloklarını
//      DEĞERLENDİRMEZ. Kırılım kararı saf bir fonksiyonda olduğunda test
//      "390px'te içerik alanı kaç piksel" sorusunu ÜRETİM KOD YOLUYLA
//      yanıtlayabilir; stil dizesine bakan bir test bunu yapamaz.
//
// Bu dosyadaki sayılar kabuğun sözleşmesidir; ekranlar kendi eşiklerini
// uydurmak yerine buradan okumalıdır.

export const SIDEBAR_WIDTH = 260;
export const SIDEBAR_COLLAPSED = 72;

// Eşikler DAHİLDİR: `width <= BREAKPOINTS.md` → md kovası.
export const BREAKPOINTS = {
  // Telefon dikey. Tarih metni gibi ikincil kabuk süsleri düşer.
  xs: 480,
  // Telefon yatay / küçük tablet. Form çekmecesi tam ekrana geçer; MUI filtre
  // diyaloğu tek kolona iner (iki kolon 390px'te kolon başına ~170px demekti).
  sm: 600,
  // Kenar çubuğu off-canvas eşiği. 260px, 900px'in %29'u: bunun altında sabit
  // kenar çubuğu içerik alanını bir DataTable'ın taşıyamayacağı kadar daraltır
  // (900px'te 640px kalır — sınırda; 768px'te 508px; 390px'te 130px).
  md: 900,
};

/** Verilen görünüm genişliğinin kovası: 'xs' | 'sm' | 'md' | 'lg'. */
export function bucketFor(viewportWidth) {
  if (viewportWidth <= BREAKPOINTS.xs) return 'xs';
  if (viewportWidth <= BREAKPOINTS.sm) return 'sm';
  if (viewportWidth <= BREAKPOINTS.md) return 'md';
  return 'lg';
}

/** Kenar çubuğu bu kovada off-canvas mı (perdeyle açılıp kapanan) ? */
export function isOffCanvasBucket(bucket) {
  return bucket !== 'lg';
}

/** Kenar çubuğu bu genişlikte off-canvas mı? */
export function isOffCanvas(viewportWidth) {
  return isOffCanvasBucket(bucketFor(viewportWidth));
}

/**
 * İçerik alanının soldan itilme miktarı (px).
 * Off-canvas modda kenar çubuğu içeriğin ÜSTÜNE biner, yer kaplamaz → 0.
 */
export function sidebarOffset(viewportWidth, collapsed = false) {
  if (isOffCanvas(viewportWidth)) return 0;
  return collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;
}

/**
 * İçerik alanının kullanılabilir genişliği (px) — FE-08'in ölçüsü.
 * 390px'te 130 → 390; 768px'te 508 → 768.
 */
export function contentAreaWidth(viewportWidth, collapsed = false) {
  return viewportWidth - sidebarOffset(viewportWidth, collapsed);
}

/** `Main`'in yatay iç boşluğu — dar ekranda 16px içerikten çok yer yiyor. */
export function mainPadding(bucket) {
  return bucket === 'xs' || bucket === 'sm' ? 10 : 16;
}

/**
 * `GenericFormDrawer`'ın geometrisi. `react-modern-drawer` genişliği `size`
 * prop'undan, gerisini inline `style`'dan okur — ikisi de CSS `@media` ile
 * değiştirilemez, bu yüzden karar burada.
 *
 * Masaüstü (`lg`) değerleri BİREBİR eski davranıştır: bu partinin masaüstünde
 * hiçbir şeyi kıpırdatmaması gerekiyor.
 */
export function drawerGeometry(bucket) {
  if (bucket === 'xs' || bucket === 'sm') {
    // Tam ekran: 390px'te 45% = 175px, `minWidth: 380` ise ekranı taşırıyordu —
    // çekmecenin sol 15px'i (kapat düğmesinin bulunduğu kenar) kesiliyordu.
    return {
      size: '100%',
      minWidth: 0,
      margin: '0',
      borderRadius: '0',
      height: '100vh',
    };
  }
  if (bucket === 'md') {
    return {
      size: '80%',
      minWidth: 0,
      margin: '12px',
      borderRadius: '6px',
      height: 'calc(100vh - 24px)',
    };
  }
  return {
    size: '45%',
    minWidth: 380,
    margin: '12px',
    borderRadius: '6px',
    height: 'calc(100vh - 24px)',
  };
}
